module.exports = __webpack_public_path__ + "static/media/MovingApp_android_4.667c77be.jpg";